<template>
    <div class="sidebar">
        <div class="sidebar-backdrop" v-on:click="closeSidebarPanel" v-if="isPanelOpen"></div>
        <transition name="slide">
            <div v-if="isPanelOpen"
                 class="sidebar-panel">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    import { store, mutations } from '@/store.js'

    export default {
        name: "Sidebar",
        methods: {
            closeSidebarPanel() {
                mutations.toggleNav()
            }
        },
        computed: {
            isPanelOpen() {
                return store.isNavOpen
            }
        }
    }
</script>

<style scoped>
    .slide-enter-active,
    .slide-leave-active {
        transition: transform 0.2s ease;
    }

    .slide-enter,
    .slide-leave-to {
        transform: translateX(-100%);
        transition: all 150ms ease-in 0s
    }

    .sidebar-backdrop {
        background-color: rgba(0, 0, 0, .7);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        cursor: pointer;
        z-index: 998;
    }

    .sidebar-panel {
        position: fixed;
        left: 0;
        top: 0;
        height: 100vh;
        width: 300px;
        overflow-y: auto;
        /*background-color: #130f40;*/
        background-color: #fff;
        padding: 10px 0;
        z-index: 999;
    }
    /*.sidebar-nav {*/
    /*    position: fixed;*/
    /*    top: 0;*/
    /*    left: 0;*/
    /*    width: 250px;*/
    /*    height: 100%;*/
    /*    z-index: 1;*/
    /*    padding: 20px;*/
    /*    box-shadow: 0 0 0 100px rgba(0,0,0,.7);*/
    /*    box-shadow: 0 0 0 100vmax rgba(0,0,0,.7);*/
    /*}*/


</style>